import { isNil, map, size } from 'lodash';
import { Component } from 'react';
import { CartesianGrid, ComposedChart, Line, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import { withWindowWidth } from '@mews/framework';
import { DEFAULT_GRID_PROPS, TICK_SIZE } from '../constants';
import { getVerticalLinePositions, renderLineFactory } from '../utils';
import { ContainerElement } from './style';
import {
    ARRIVALS_LINE_PROPS,
    BAR_CATEGORY_GAP,
    CHART_HEIGHT,
    CONTAINER_PROPS,
    DEPARTURES_LINE_PROPS,
    NUMBER_AXIS_PROPS,
    NUMBER_AXIS_WIDTH,
    PERCENT_AXIS_PROPS,
    PERCENT_AXIS_WIDTH,
    X_AXIS_PROPS,
} from './constants';
import withOccupancyBars from './withOccupancyBars';

interface OccupancyChartProps {
    data: {}[];
    occupancyDomain: number[];
    renderBars: $TSFixMeFunction;
    renderLegend: $TSFixMeFunction;
}

class OccupancyChart extends Component<OccupancyChartProps> {
    container: $TSFixMe;

    getContainerWidth = () => {
        if (isNil(this.container)) {
            return 0;
        }
        return this.container.clientWidth;
    };

    containerRef = (c: $TSFixMe) => (this.container = c);

    render() {
        const { data, renderBars, renderLegend, occupancyDomain } = this.props;
        return (
            <ContainerElement ref={this.containerRef}>
                {renderLegend()}
                <ResponsiveContainer {...CONTAINER_PROPS}>
                    <ComposedChart data={data} barCategoryGap={BAR_CATEGORY_GAP}>
                        {map(
                            getVerticalLinePositionFromProps({ data, chartWidth: this.getContainerWidth() }),
                            renderLine
                        )}
                        <XAxis {...X_AXIS_PROPS} />
                        <YAxis {...PERCENT_AXIS_PROPS} domain={occupancyDomain} />
                        {/* @ts-expect-error $TSFixMeError: Type '{ orientation: string; yAxisId: string; width: number; tickLine: boolean; axisLine: boolean; tickSize: number; }' ... */}
                        <YAxis {...NUMBER_AXIS_PROPS} />
                        <CartesianGrid {...DEFAULT_GRID_PROPS} />
                        {renderBars()}
                        <Line {...ARRIVALS_LINE_PROPS} />
                        <Line {...DEPARTURES_LINE_PROPS} />
                    </ComposedChart>
                </ResponsiveContainer>
            </ContainerElement>
        );
    }
}

export default withWindowWidth(withOccupancyBars(OccupancyChart));

const renderLine = renderLineFactory({ yEndOffset: TICK_SIZE, chartHeight: CHART_HEIGHT });

const getVerticalLinePositionFromProps = ({ data, chartWidth }: $TSFixMe) =>
    getVerticalLinePositions({
        dataSize: size(data),
        chartWidth,
        xStartOffset: PERCENT_AXIS_WIDTH + TICK_SIZE,
        xEndOffset: NUMBER_AXIS_WIDTH + TICK_SIZE,
    });
